import { throttle } from 'lodash-es';
import React, { useEffect, useMemo, useState } from 'react';
export const VIEWPORT_CONTENT_LAYOUT_CLASS_NAME = {
    default: undefined,
    block: '[&>div]:!block [&>div]:w-full [&>div]:!min-w-0',
    maxContent: '[&>div]:!block [&>div]:w-max [&>div]:min-w-full',
    flexColumn: '[&>div]:!flex [&>div]:min-h-full [&>div]:w-full [&>div]:!min-w-0 [&>div]:flex-col',
};
export const useScrollBoundaries = (scrollRef, threshold = 10, throttleTime = 250) => {
    const [isScrolledToLeft, setIsScrolledToLeft] = useState(true);
    const [isScrolledToRight, setIsScrolledToRight] = useState(false);
    useEffect(() => {
        const checkBoundaries = () => {
            if (scrollRef.current) {
                const scrollLeft = scrollRef.current.scrollLeft;
                const scrollWidth = scrollRef.current.scrollWidth;
                const clientWidth = scrollRef.current.clientWidth;
                const maxScroll = scrollWidth - clientWidth;
                setIsScrolledToLeft(scrollLeft <= threshold);
                setIsScrolledToRight(scrollLeft >= maxScroll - threshold);
            }
        };
        const handleScroll = throttle(checkBoundaries, throttleTime, {
            leading: true,
            trailing: true,
        });
        const element = scrollRef.current;
        element?.addEventListener('scroll', handleScroll);
        checkBoundaries();
        return () => {
            element?.removeEventListener('scroll', handleScroll);
            handleScroll.cancel();
        };
    }, [scrollRef, threshold, throttleTime]);
    return useMemo(() => ({ isScrolledToLeft, isScrolledToRight }), [isScrolledToLeft, isScrolledToRight]);
};
//# sourceMappingURL=ScrollAreaShared.js.map